const state = {
    loginUser: {},
    token: '',
    isLogin: false,
    authList: {
        isAdmin: false,
        isActer: false,
        isEditer: false,
        isReader: false
    },
    expiredTime: '' // 預設為空字串
};
export default {
    namespaced: true,
    state,
    mutations: {
        SET_AUTH(state, options) {
            const { loginUser, token, isLogin } = options;
            // console.log(isLogin, loginUser)
            const { authList } = state;
            if (isLogin) {
                const { roles } = loginUser;
                authList.isAdmin = JSON.stringify(roles).includes('MGR-');
                authList.isActer = roles.includes('MGR-ACTER');
                authList.isEditer = roles.includes('MGR-EDITER');
                authList.isReader = roles.includes('MGR-READER');
                state.loginUser = loginUser;
                state.expiredTime = new Date();
            }
            else {
                state.loginUser = {};
                authList.isAdmin = false;
                authList.isActer = false;
                authList.isEditer = false;
                authList.isReader = false;
            }
            state.token = token;
            state.isLogin = isLogin;
        }
    },
    actions: {
        setAuth(context, options) {
            context.commit('SET_AUTH', options);
        }
    }
};
